export const DefaultOlympeConfigFile = {
  name: "olympe",
  light: {
    colorSchema: {
      logo: {
        secondary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/primary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/primary-logo-light.svg',
          style: {
            width: 75,
            height: 50
          },
        },
        primary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/primary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/primary-logo-light.svg',
          style: {
            width: 75,
            height: 50
          },
        },
        main: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/main-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/main-logo-dark.svg',
          style: {
            width: 170,
            height: 75
          },
        },
      },
      inputs: {
        secondary: {
          background: "#DBC7AC",
          text: "#FFFFFF",
          outline: "#DBC7AC",
          icon: "#FFFFFF",
        },
        plus: {
          background: ["#6B7A8E", "#6B7A8E"],
          text: "#FFE300",
          outline: "#6B7A8E",
          icon: "#FFE300",
        },
        primary: {
          background: ["#FFFFFF", "#FFFFFF"],
          text: "#6B7A8E",
          outline: "#6B7A8E",
          icon: "#FFFFFF",
        },
      },

      buttons: {
        secondary: {
          background: "#FFFFFF",
          text: "#777777",
          outline: "#777777",
          icon: "#1A2954",
        },
        plus: {
          background: ["#6B7A8E", "#6B7A8E"],
          text: "#FFE300",
          outline: "#6B7A8E",
          icon: "#FFE300",
        },
        primary: {
          background: ["#1A2954", "#2B448D"],
          text: "#FFFFFF",
          outline: "transparent",
          icon: "#FFFFFF",
        },
      },
      colors: {
        secondary: "#F5900C",
        progressBarDashboard: ["#F5900C", "#D67A03"],
        secondaryBackground: "#F6F6F6",
        mainBackground: "#FFFFFF",
        profilePictureStroke: "#F5900C",
        text: "#949494",
        mainText: "#000000",
        primary: "#1A2954",
        secondaryText: "#6B6B6B",
        thirdText: "#FFE998",
        inputBackground: "#FFFFFF",
        thirdBackground: "#E7E6E6",
      },
      background: {
        profileMain: {
          dark:
          "https://themes.elisyanwealth.com/admin-dashboard/olympe/background/dashboard-background.svg", 
          light:
          "https://themes.elisyanwealth.com/admin-dashboard/olympe/background/dashboard-background.svg",
          style: {
            width: 0.15,
          },
        }
      } 
    },
  },
  dark: {
    colorSchema: {
      logo: {
        secondary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/primary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/primary-logo-light.svg',
          style: {
            width: 75,
            height: 50
          },
        },
        primary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/primary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/primary-logo-light.svg',
          style: {
            width: 75,
            height: 50
          },
        },
        main: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/main-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/olympe/logo/main-logo-dark.svg',
          style: {
            width: 170,
            height: 75
          },
        },
      },
      inputs: {
        secondary: {
          background: "#DBC7AC",
          text: "#FFFFFF",
          outline: "#DBC7AC",
          icon: "#FFFFFF",
        },
        plus: {
          background: ["#6B7A8E", "#6B7A8E"],
          text: "#FFE300",
          outline: "#6B7A8E",
          icon: "#FFE300",
        },
        primary: {
          background: ["#FFFFFF", "#FFFFFF"],
          text: "#6B7A8E",
          outline: "#6B7A8E",
          icon: "#FFFFFF",
        },
      },
      buttons: {
        secondary: {
          background: "#DBC7AC",
          text: "#6B7A8E",
          outline: "#DBC7AC",
          icon: "#FFFFFF",
        },
        plus: {
          background: ["#6B7A8E", "#6B7A8E"],
          text: "#FFE300",
          outline: "#6B7A8E",
          icon: "#FFE300",
        },
        primary: {
          background: ["#FFE998", "#FFE998"],
          text: "#6B7A8E",
          outline: "#6B7A8E",
          icon: "#FFFFFF",
        },
      },
      colors: {
        secondary: "#6B7A8E",
        progressBarDashboard: ["#FFE998", "#57370D"],
        secondaryBackground: "#6B7A8E",
        mainBackground: "#6B7A8E",
        profilePictureStroke: "#FFE998",
        text: "#FFFFFF",
        mainText: "#FFFFFF",
        primary: "#595959",
        secondaryText: "#6B6B6B", //'#DBC7AC',
        thirdText: "#FFE998",
        inputBackground: "#FFFFFF",
        thirdBackground: "#E7E6E6",
      },
      background: {
        profileMain: {
          dark:
          "https://themes.elisyanwealth.com/admin-dashboard/olympe/background/dashboard-background.svg", 
          light:
          "https://themes.elisyanwealth.com/admin-dashboard/olympe/background/dashboard-background.svg",
          style: {
            width: 0.15,
          },
        }
      } 
    },
  },
  text:{
    en:{
      welcomeScreen: "Securely Track your Global Wealth",
      signupScreen: "Securely Track your Global Wealth",
      loginScreen: "Welcome to Olympe Gestion Patrimoine",
      loginScreenRegister: "New to Olympe Gestion Patrimoine?",
      welcomeModal: "Securely Track your Global Wealth",
    },
    fr:{
      welcomeScreen: "Suivez votre patrimoine mondial en toute sécurité",
      signupScreen: "Suivez votre patrimoine mondial en toute sécurité",
      loginScreen: "Bienvenue sur Olympe Gestion Patrimoine",
      loginScreenRegister: "Nouveau sur Olympe Gestion Patrimoine ?",
      welcomeModal: "Suivez votre patrimoine mondial en toute sécurité",
    }
  }
};
